export default __webpack_public_path__ + "static/media/clear-wishlist.d6215ebc.svg";